import { useTranslation } from 'next-i18next';
import React from 'react';

import Confirmation from 'components/Confirmation';
import Modal from 'components/Modal';

interface DeleteModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  type: string;
  isButtonLoading: boolean;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  type,
  isButtonLoading,
}) => {
  const [t] = useTranslation('candidate.profile.modal');
  return (
    <Modal isOpen={isOpen} onRequestClose={onCancel} isFullScreen={false}>
      <Confirmation
        title={t('delete-modal.title', { type })}
        desc={t('delete-modal.description', { type })}
        buttonContent={'Yes, Delete'}
        onCancel={onCancel}
        isLoading={isButtonLoading}
        onConfirm={onConfirm}
        isPrimary={false}
        secondaryActionOnRight={true}
      />
    </Modal>
  );
};

DeleteModal.displayName = 'DeleteModal';
